import { render, staticRenderFns } from "./VisitsCalendar.vue?vue&type=template&id=610827bc&scoped=true&"
import script from "./VisitsCalendar.vue?vue&type=script&lang=js&"
export * from "./VisitsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./VisitsCalendar.vue?vue&type=style&index=0&id=610827bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610827bc",
  null
  
)

export default component.exports